<template>
  <div class="page-wrap d-flex flex-row align-items-center">
    <b-container id="cubejs-page" class="mb-5">
      <h1 class="mt-3 mb-3 d-block page-title">API</h1>
      <div class="mb-4 lead">
        <p>
          La ricerca dei dati nel resi disponibili è possibile tramite API REST realizzate con
          <a
            href="https://cube.dev/docs/rest-api#api-reference-v-1-sql"
            target="_blank"
          >CubeJS</a>.
        </p>

        <ul>
          <li>
            <a
              href="https://dih.linkalab-cloud.com/cubejs-api/v1/meta"
              target="_blank"
            >Meta: https://dih.linkalab-cloud.com/cubejs-api/v1/meta</a>
          </li>
          <li>
            <a
              href="https://dih.linkalab-cloud.com/cubejs-api/v1/load?query={...}"
            >Load: https://dih.linkalab-cloud.com/cubejs-api/v1/load?query={...}</a>
          </li>
        </ul>

        <p>
          Per interrogare le API, le URL da utilizzare sono le seguenti:
          dove `{...}` in Load conterrà i parametri individuati in Meta.
          <br />
          <br />Ad esempio:
          <a :href="exampleHref" target="_blank">{{ exampleHref }}</a>
          <br />
          <img src="/datacatalog-simple/images/cubejs.png" style="max-width:80%" />
        </p>
      </div>
      <b-button variant="outline-primary" size="sm" :to="{ name: 'home' }">Torna alla home</b-button>
    </b-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      exampleHref: 'https://dih.linkalab-cloud.com/cubejs-api/v1/load?query={"measures":["Ristorante.count"],"timeDimensions":[{"dimension":"Ristorante.data","granularity":"day"}]}'
    }
  }
}
</script>
